export default function FormatTableDurationModule(element) {

    // Reemplazamos 00:10h por 10m
    element.querySelectorAll('td').forEach(function(td) {
        let text = td.innerText;
        if (!text.match(/^\d+:\d+h$/)) {
            return;
        }


        td.innerText = text.replace(/^0+:(\d+)h$/, '$1m');

    });


   
    return this;
}
